import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import ReviewsByRating from '../Reviews/ReviewsByRating';
import MobileDrawerHeader from '../UI/MobileDrawerHeader';
import TitleDataStore from './containers/TitleDataStore';
import TitleBiblio from './TitleBiblio';
import TitleYourLists from './TitleYourLists';
import TitleYourReview from './TitleYourReview';
import TitleYourNominations from './TitleYourNominations';
import { usePreferences } from '../Preferences/containers/PreferencesDataStore';
import PreferenceName from '../Preferences/PreferenceName';
import './titleDetail.less';
import TitleConversations from './TitleConversations';
import PreferenceType from '../Preferences/PreferenceType';
import { Translate } from '@above-the-treeline/localization';
import classNames from 'classnames';
import { useUser } from '../User/containers/UserDataStore';
import TitleDetailJacket from './TitleDetailJacket';

export function TitleDetail({ sku, communityId, isMobile }) {
	const isMobileSize = isMobile();
	const preferencesDataStore = usePreferences();
	const { preferences } = preferencesDataStore.state;
	const [doShowTitleJacket, setDoShowTitleJacket] = React.useState(true);
	const [doShowSmallJacket, setDoShowSmallJacket] = React.useState(
		preferences.findIndex(
			pref =>
				pref.name === PreferenceName.showSmallJacket &&
				pref.value === 'true',
		) !== -1,
	);

	const isAnonymous = useUser().isAnonymous();

	React.useEffect(() => {
		setShowSmallJacketPreference();
	}, [doShowSmallJacket]);

	const getBiblioFrameContainerClasses = () =>
		classNames('biblio-frame-container', {
			'small-jacket-biblio': doShowSmallJacket,
			'wide-jacket-biblio': !doShowSmallJacket && doShowTitleJacket,
			'full-width': !doShowSmallJacket && !doShowTitleJacket,
		});

	const setShowSmallJacketPreference = () => {
		preferencesDataStore.addUserPreference(
			PreferenceType.communityApp,
			PreferenceName.showSmallJacket,
			doShowSmallJacket,
		);
	};

	return (
		<div className={classNames('title-detail', { desktop: !isMobileSize })}>
			<MobileDrawerHeader header={<Translate id="title_information" />} />
			<TitleDataStore sku={sku} communityId={communityId}>
				{!isMobileSize ? (
					<>
						<div
							className={`jacket-frame-container ${
								doShowSmallJacket
									? 'small-jacket'
									: 'wide-jacket'
							}`}>
							{doShowTitleJacket && (
								<TitleDetailJacket
									doShowSmallJacket={doShowSmallJacket}
									setDoShowSmallJacket={setDoShowSmallJacket}
									setDoShowTitleJacket={setDoShowTitleJacket}
								/>
							)}
							{doShowSmallJacket && (
								<>
									<TitleYourLists sku={sku} />
									{!isAnonymous && (
										<TitleYourNominations
											sku={sku}
											showSmallJacket={true}
											isMobileSize={false}
										/>
									)}
								</>
							)}
						</div>
						<div className={getBiblioFrameContainerClasses()}>
							<TitleBiblio
								disableLink="true"
								source="titleDetail"
							/>
							{!doShowSmallJacket && <TitleYourLists sku={sku} />}
							<TitleConversations sku={sku} />
							<TitleYourReview sku={sku} />
							{!doShowSmallJacket && !isAnonymous && (
								<TitleYourNominations
									sku={sku}
									showSmallJacket={false}
									isMobile={false}
								/>
							)}
							<ReviewsByRating communityId={communityId} />
						</div>
						<div className="clear" />
					</>
				) : (
					<>
						{doShowTitleJacket && (
							<TitleDetailJacket
								setDoShowTitleJacket={setDoShowTitleJacket}
							/>
						)}
						<TitleBiblio disableLink="true" source="titleDetail" />
						<TitleYourLists sku={sku} />
						<TitleYourReview sku={sku} />
						<TitleConversations sku={sku} />
						{!isAnonymous && (
							<TitleYourNominations
								sku={sku}
								showSmallJacket={false}
								isMobile={true}
							/>
						)}
						<ReviewsByRating communityId={communityId} />
					</>
				)}
			</TitleDataStore>
		</div>
	);
}

export default withIsMobile(TitleDetail);
